import { LegalLayout, LegalSection } from "@/components/LegalLayout";
import { BUSINESS } from "@/data/business";

export default function Terms() {
  return (
    <LegalLayout
      title="Terms & Conditions"
      crumbName="Terms & Conditions"
      path="/terms"
      description="Terms and conditions for JK House Cleaning residential cleaning services in Melbourne."
    >
      <p>
        These terms apply to residential cleaning services provided by {BUSINESS.name} (ABN {BUSINESS.abn}). By
        requesting a quote or booking a service, you agree to these terms.
      </p>

      <LegalSection heading="Quotes">
        <p>All quotes are free and provided on a no-obligation basis. Quotes are estimates based on the
          information you provide and may be adjusted if the property differs significantly from the details
          supplied, or if additional work is requested.</p>
      </LegalSection>

      <LegalSection heading="Bookings">
        <p>A booking is confirmed once we have agreed a date, time and scope of work with you. Please provide
          accurate access arrangements and property details so we can deliver the service as planned.</p>
      </LegalSection>

      <LegalSection heading="Property access">
        <p>You are responsible for arranging safe and reasonable access to the property, whether you are home or
          provide a key, lockbox or building access. Please secure any pets during the clean.</p>
      </LegalSection>

      <LegalSection heading="Our service">
        <p>We supply our own professional cleaning equipment and products. We carry out cleaning with care and
          attention to detail. Some services depend on availability, including same-day and emergency cleaning.</p>
      </LegalSection>

      <LegalSection heading="Insurance">
        <p>{BUSINESS.name} holds Public Liability Insurance. Please notify us promptly of any concerns so we can
          address them.</p>
      </LegalSection>

      <LegalSection heading="Payment">
        <p>Payment terms will be confirmed with your quote and booking. Any pricing shown in a quote is specific
          to that quote.</p>
      </LegalSection>

      <LegalSection heading="Liability">
        <p>To the extent permitted by Australian Consumer Law, our liability is limited to the re-supply of the
          relevant cleaning service. Nothing in these terms excludes rights you have under applicable law.</p>
      </LegalSection>

      <LegalSection heading="Contact">
        <p>For any questions about these terms, contact us at {BUSINESS.email} or {BUSINESS.phoneDisplay}.</p>
      </LegalSection>
    </LegalLayout>
  );
}
